import * as React from 'react'
import {
  buildTimeSlots,
  MuiDatePickerFormik,
  TimePicker,
} from '@user/components/Formik'
import { Field } from 'formik'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useStartDateManagement } from '../hooks'

const timeSlots = buildTimeSlots(15, 1, 24)

export function StartDatePicker() {
  const { timeDisabled } = useStartDateManagement()

  return (
    <Stack>
      <Typography variant="body1" mt={2} mb={1} fontSize={16}>
        Start Date
      </Typography>
      <Stack spacing={1} direction="row" alignItems="start">
        <Field
          name="startDate"
          component={MuiDatePickerFormik}
          fullWidth
          size="medium"
          placeholder="Date"
          popperPlacement="auto"
          tidalAdditionalStyling
          disableTether
          clearable
          data-test-id={`activity-form-start-date-picker`}
        />
        <TimePicker
          fullWidth
          name="startTime"
          label=""
          allowUnlistedTimes
          timeSlots={timeSlots}
          size="small"
          disabled={timeDisabled}
          placeholder="Time"
          tidalAdditionalStyling
          testId={`activity-form-start-time-picker`}
        />
      </Stack>
    </Stack>
  )
}
